import { useMemo } from 'react';

// components
import {
  CasRHFDatePicker,
  IEditForm,
  CasEditForm,
  CasRHFTextField,
  CasRHFLexicalRichTextEditor,
} from 'src/compass/shared/components';
import { CasRHFSharepointSiteSelect } from 'src/compass/application';

import { usePeriodDatesInvalidateQuery } from 'src/compass/shared/hooks/usePeriodDates';
import { formatDate, DateFormat } from 'src/compass/shared/util/casMoment';
// schema
import { CommissionSchema } from './CommissionSchema';

export default function CommissionForm({ row, onSaved }: IEditForm) {
  const defaultValues = useMemo(() => row, [row]);
  const invalidatePeriodStartDate = usePeriodDatesInvalidateQuery();

  const onBeforeSave = (data: any) => ({
    ...data,
    closedThruDate: formatDate(data.closedThruDate, DateFormat.YMD),
  });

  const onSaveSuccess = (data: any) => {
    invalidatePeriodStartDate();
    onSaved(data);
  };

  return (
    <CasEditForm
      defaultValues={defaultValues}
      onSaved={onSaveSuccess}
      entity="CommissionProperty"
      schema={CommissionSchema}
      onBeforeSave={onBeforeSave}
    >
      <CasRHFDatePicker
        name="closedThruDate"
        label="Closed through date"
        helperText="Commissions processing has been closed through this date"
      />
      <CasRHFTextField label="CME Payroll Export Code (1099)" name="cmePayrollExportCode_1099" />
      <CasRHFTextField label="CME Payroll Export Code (Employee)" name="cmePayrollExportCode_Employee" />
      <CasRHFTextField label="LRP Payroll Export Code (1099)" name="lrpPayrollExportCode_1099" />
      <CasRHFTextField label="LRP Payroll Export Code (Employee)" name="lrpPayrollExportCode_Employee" />
      <CasRHFSharepointSiteSelect label="Sharepoint Site" name="sharepointSiteId" />
      <CasRHFTextField label="Sharepoint Root" name="sharepointRoot" />
      <CasRHFLexicalRichTextEditor mode='simple' label="Prelim Email Template" name="prelimEmailTemplate" />
    </CasEditForm>
  );
}
